import { ToggleExtra } from '@common/components/Extras/controls';
import { GuestSelectorComponentProps } from '@common/components/Extras/controls/sharedTypes';
import QuantityPicker from '@common/components/QuantityPicker';
import {
  BottomRow,
  ToggleExtraWrapper,
  TopRow,
} from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/Options/Options.styles';
import { OptionsBox } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/Options/OptionsBox';
import { Controller, FieldPath, useFormContext, useWatch } from 'react-hook-form';
import { RoomExtra, RoomExtraOption } from 'shared-types/Room';
import { RoomRateFormValues } from '../../../RoomRateFormV2.schema';
import { controlTypesV2 } from './controlTypes/controlTypesV2';

const extrasField = (id: string | number, field: string) =>
  `extras.${id}.${field}` as FieldPath<RoomRateFormValues>;

type OptionsV2Props = {
  selectedOption?: RoomExtraOption;
} & RoomExtra;

export const OptionsV2 = ({ selectedOption, ...extra }: OptionsV2Props) => {
  const { control } = useFormContext<RoomRateFormValues>();
  const { id } = extra;
  const maxQuantity = selectedOption?.maxQuantity || extra?.maxQuantity;

  const currentIsSelected = useWatch({ control, name: extrasField(id, 'isSelected') });

  return (
    <OptionsBox>
      <TopRow>{controlTypesV2(extra as RoomExtra)}</TopRow>
      <BottomRow>
        {!!maxQuantity && (
          <Controller
            control={control}
            name={extrasField(id, 'quantity')}
            render={({ field: { value, onChange } }) => (
              <QuantityPicker
                input={{ value: (value as number) ?? 1, onChange }}
                maxValue={maxQuantity}
              />
            )}
          />
        )}
        <ToggleExtraWrapper>
          <Controller
            control={control}
            name={extrasField(id, 'isSelected')}
            render={({ field: { value, onChange } }) => (
              <ToggleExtra
                input={{
                  value: value as boolean,
                  onChange: onChange as GuestSelectorComponentProps['input']['onChange'],
                }}
                isDisabled={!currentIsSelected && !selectedOption}
              />
            )}
          />
        </ToggleExtraWrapper>
      </BottomRow>
    </OptionsBox>
  );
};
